export default "/images/cced216ff574b8e25bbb3050494b5cd3.avif";